<template>
  <PageWrapper
    :active-page="PAGE_MY_COLLABORATOR_PROPOSALS"
    :active-section="SECTION_PUBLICATIONS"
    title="My Proposals"
    :breadcrumbs="publicationBreadCrumbs"
    page-name="My Proposals"
    align="left"
    width="full"
  >
    <SmartFeed
      :source="useMyCollaboratorProposalFeedStore"
      default-feed-layout="table"
    >
      <template #empty-state>
        <iColumn gap="extraSmall" align="left">
          <iText variant="subtle">
            You currently have no pending invitations to collaborate on any
            publications.
          </iText>
        </iColumn>
      </template>
    </SmartFeed>

    <InvitationReviewModal
      v-if="isInvitationReviewModalVisible"
      :invitation="selectedInvitationReview"
      @close="closeInvitationReviewModal"
      @accept="onAcceptInvitation"
      @decline="onDeclineInvitation"
      @counter="onCounterInvitation"
    />

    <ProposalReviewModal
      v-if="isProposalReviewModalVisible"
      :proposal="selectedProposalReview"
      :show-invite-by="false"
      @close="closeProposalReviewModal"
      @accept="onAcceptInvitation"
      @decline="onDeclineInvitation"
      @counter="onCounterInvitation"
    />

    <CounterOfferModal
      v-if="isCounterOfferModalVisible"
      :proposal="selectedProposalForCounter"
      @close="closeCounterOfferModal"
      @cancel="onCancelCounterOffer"
      @submit="onSubmitCounterOffer"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_MY_COLLABORATOR_PROPOSALS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import CounterOfferModal from "@/components/publication/CounterOfferModal.vue";
import InvitationReviewModal from "@/pages/publication/InvitationReviewModal.vue";
import ProposalReviewModal from "@/components/publication/ProposalReviewModal.vue";
import { mapActions, mapState } from "pinia";
import { useCollaboratorStore } from "@/stores/collaborator-store";
import { useMyCollaboratorProposalFeedStore } from "@/smart-feed/stores/feed/my-collaborator-proposal-feed-store";

export default {
  name: "CollaboratorProposals",
  components: {
    InvitationReviewModal,
    ProposalReviewModal,
    CounterOfferModal,
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      PAGE_MY_COLLABORATOR_PROPOSALS,
      SECTION_PUBLICATIONS,
      selectedProposalForCounter: null,
    };
  },
  computed: {
    ...mapState(useCollaboratorStore, [
      "isCounterOfferModalVisible",
      "isInvitationReviewModalVisible",
      "isProposalReviewModalVisible",
      "selectedInvitationReview",
      "selectedProposalReview",
    ]),
    publicationBreadCrumbs() {
      return [{ url: "/", label: "Home" }];
    },
  },
  methods: {
    useMyCollaboratorProposalFeedStore,
    ...mapActions(useCollaboratorStore, [
      "acceptInvitation",
      "denyInvitation",
      "openApplicationReviewModal",
      "closeCounterOfferModal",
      "openCounterOfferModal",
      "openInvitationReviewModal",
      "closeInvitationReviewModal",
      "openProposalReviewModal",
      "closeProposalReviewModal",
      "createCounterOffer",
    ]),
    onAcceptInvitation() {
      const invitation =
        this.selectedInvitationReview || this.selectedProposalReview;
      this.acceptInvitation(
        invitation.publicationId,
        invitation.orgId,
        invitation.contract.contract_id,
      );
    },
    onDeclineInvitation() {
      const invitation =
        this.selectedInvitationReview || this.selectedProposalReview;
      this.denyInvitation(invitation.publicationId, invitation.orgId);
    },
    onCounterInvitation(proposal) {
      this.selectedProposalForCounter = proposal || this.selectedProposalReview;

      if (this.isInvitationReviewModalVisible) {
        this.closeInvitationReviewModal();
      }

      if (this.isProposalReviewModalVisible) {
        this.closeProposalReviewModal();
      }

      this.openCounterOfferModal();
    },
    onSubmitCounterOffer(formData) {
      this.createCounterOffer(this.selectedProposalForCounter, formData);
      this.selectedProposalForCounter = null;
    },
    onCancelCounterOffer() {
      this.closeCounterOfferModal();
      this.openProposalReviewModal(this.selectedProposalForCounter);
    },
  },
};
</script>
